// Keep diagnostics available while developing; suppress app console output
// in the production dashboard bundle.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  ['log', 'debug', 'info', 'warn', 'error'].forEach((method) => {
    console[method] = noop;
  });
}
